module.exports = __webpack_public_path__ + "static/frontpage-hero-background-800-663ce0a23c75dfb79cc86cf440ffa63c.jpg";